import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: classNames.ArgumentArray) {
    return twMerge(classNames(inputs));
}

export function getAvatarFallbackName(fullname?: string) {
    if (!fullname) return '';
    const names = fullname.trim().split(' ');

    if (names.length === 1) {
        return `${names[0].charAt(0).toUpperCase()}${names[0].charAt(1).toUpperCase()}`;
    } else if (names.length > 1) {
        const firstInitial = names[0].charAt(0).toUpperCase();
        const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
        return `${firstInitial}${lastInitial}`;
    }

    return '';
}

export function calculateTaxIncludedPrice(price: number) {
    return Math.round(price * 1.1);
}

/**
 * Format Japanese Yen currency
 * @param {number} amount - The amount (e.g., 123456.789)
 * @param {string} type - 'symbol' for ¥ (international), 'kanji' for 円 (Japan). Default: 'symbol'
 * @param {boolean} noDecimals - Yen does not use decimals, default true (rounds to integer)
 * @returns {string} Formatted currency string
 */
export function formatPrice(amount: number, type = 'kanji', noDecimals = true) {
    // Round to integer since Yen has no cent/sen
    const value = noDecimals ? Math.round(amount) : amount;

    if (type === 'symbol') {
        return new Intl.NumberFormat('ja-JP', {
            style: 'currency',
            currency: 'JPY'
            // Optionally: minimumFractionDigits: 0 to hide decimals
        }).format(value);
    }

    const formattedNumber = new Intl.NumberFormat('ja-JP').format(value);
    return formattedNumber + ' 円';
}
